import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Anchor, Button, Text } from '@mantine/core';
import AuthCard from '@/components/auth/AuthCard';
import { ROUTES } from '@/routes/paths';

interface RegisterSuccessProps {
  readonly email: string;
  readonly resendActive: boolean;
  readonly resendRemaining: number;
  readonly onResend: () => void;
}

// Экран после успешной регистрации. Ссылка из письма сама открывает кабинет (FR-REG-11), поэтому главное здесь — письмо;
// вход — запасной путь для тех, кто уже подтвердил адрес.
export default function RegisterSuccess({
  email,
  resendActive,
  resendRemaining,
  onResend,
}: RegisterSuccessProps) {
  const { t } = useTranslation();

  return (
    <AuthCard
      title={t('auth.register.successTitle')}
      description={t('auth.register.successText', { email })}
      footer={
        <Text size="sm">
          {t('auth.register.alreadyConfirmed')}{' '}
          <Anchor component={Link} to={ROUTES.LOGIN} c="brand.7" underline="always">
            {t('auth.register.toLogin')}
          </Anchor>
        </Text>
      }
    >
      <Button variant="default" w="fit-content" disabled={resendActive} onClick={onResend}>
        {resendActive
          ? t('auth.register.resendRetry', { seconds: resendRemaining })
          : t('auth.register.resend')}
      </Button>
    </AuthCard>
  );
}
